import { Injectable } from '@angular/core';
import { ConditionColumns } from '../conditions/condition-list/condition-columns.config';
import { AnalyteColumns } from '../samples/sample-list/analyte-columns.config';
import { SampleColumns } from '../samples/sample-list/sample-columns.config';
import { StudyType } from './labpartner.service.model';

//Interface for the configuration of each study type
export interface StudyTypeConfig {
  hasAnalytes: boolean;
  enableDIPTab?: boolean;
  experimentDIPFileName?: string;
  bundleDIPFileName?: string;
  sampleColumns?: any[];
  analyteColumns?: any[];
  conditionColumns?: any[];
}

// Configuration for each study type

export const LoDRangeFindingStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: true,
  experimentDIPFileName: 'LoD - Range Finding',
  bundleDIPFileName: 'LoD',
  sampleColumns: SampleColumns.lodSampleColumns,
  analyteColumns: AnalyteColumns.lodAnalyteColumns,
  conditionColumns: ConditionColumns.lodColumns,
};
export const LoDConfirmationStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: true,
  experimentDIPFileName: 'LoD - Confirmation',
  bundleDIPFileName: 'LoD',
  sampleColumns: SampleColumns.lodSampleColumns,
  analyteColumns: AnalyteColumns.lodAnalyteColumns,
  conditionColumns: ConditionColumns.lodColumns,
};

export const ImportExcelStudyConfig: StudyTypeConfig = {
  hasAnalytes: false,
  enableDIPTab: false,
};

export const GeneralStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: false,
  sampleColumns: SampleColumns.generalColumns,
  analyteColumns: AnalyteColumns.generalAnalyteColumns,
  conditionColumns: ConditionColumns.generalColumns,
};

export const DailyExternalControlsStudyConfig: StudyTypeConfig = {
  hasAnalytes: false,
  enableDIPTab: false,
  sampleColumns: SampleColumns.dailyExternalControlsSampleColumns,
  conditionColumns: ConditionColumns.dailyExternalControlsColumns,
};

export const PrecisionStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: true,
  experimentDIPFileName: 'Precision',
  bundleDIPFileName: 'Precision',
  sampleColumns: SampleColumns.precisionSampleColumns,
  analyteColumns: AnalyteColumns.precisionAnalyteColumns,
  conditionColumns: ConditionColumns.precisionColumns,
};

export const InterferingSubstancesStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: true,
  experimentDIPFileName: 'Interfering Substances',
  bundleDIPFileName: 'Interfering Substances',
  sampleColumns: SampleColumns.intSubsSampleColumns,
  analyteColumns: AnalyteColumns.intSubsAnalyteColumns,
  conditionColumns: ConditionColumns.intSubsColumns,
};
export const CrossReactivityAndMicrobialInterferenceStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: true,
  experimentDIPFileName: 'Cross Reactivity and Microbial Interference',
  bundleDIPFileName: 'Cross Reactivity and Microbial Interference',
  sampleColumns: SampleColumns.crossReactivityAndMicrobialInterferenceSampleColumns,
  analyteColumns: AnalyteColumns.crossReactivityAndMicrobialInterferenceAnalyteColumns,
  conditionColumns: ConditionColumns.crossReactivityAndMicrobialInterferenceAnalyteColumns,
};

export const TransportMediaAndSpecimenStabilityStudyConfig: StudyTypeConfig = {
  hasAnalytes: true,
  enableDIPTab: true,
  experimentDIPFileName: 'Interfering Substances',
  bundleDIPFileName: 'Interfering Substances',
  sampleColumns: SampleColumns.transportMediaAndSpecimenStabilitySampleColumns,
  analyteColumns: AnalyteColumns.transportMediaAndSpecimenStabilityAnalyteColumns,
  conditionColumns: ConditionColumns.transportMediaAndSpecimenStabilityColumns,
};

@Injectable({
  providedIn: 'root',
})
export class StudyTypeService {
  // Returns the configuration for the study type
  getStudyTypeConfig(studyType: StudyType | undefined) {
    switch (studyType) {
      case StudyType.LoDRangeFinding:
        return LoDRangeFindingStudyConfig;
      case StudyType.LoDConfirmation:
        return LoDConfirmationStudyConfig;
      case StudyType.ImportExcel:
        return ImportExcelStudyConfig;
      case StudyType.General:
        return GeneralStudyConfig;
      case StudyType.DailyExternalControls:
        return DailyExternalControlsStudyConfig;
      case StudyType.Precision:
        return PrecisionStudyConfig;
      case StudyType.InterferingSubstances:
        return InterferingSubstancesStudyConfig;
      case StudyType.CrossReactivityAndMicrobialInterference:
        return CrossReactivityAndMicrobialInterferenceStudyConfig;
      case StudyType.TransportMediaAndSpecimenStability:
        return TransportMediaAndSpecimenStabilityStudyConfig;
      default:
        return null;
    }
  }
}
